import { PolicyType } from "@graphql/api";

export const mapPolicyTypeToPOCType = (
  policyType: PolicyType | null | undefined
) => {
  if (policyType === PolicyType.HomeOwners) return "Covertree";

  return "External";
};
